import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, Table, TableHead, TableRow, TableCell, TableBody, Tab, } from '@material-ui/core';
import Apis from '../../../network/Apis';
import MatchType from '../../../model/MatchType';
import MNoLiving from '../../view/MNoLiving';

class MatchRankPlayerFootball extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectIdex: 100,
            data: [],
            tabData: ['助攻', '关键传球', '抢断', '扑救', '过人']
        };

        this.HttpUrlPlayer = 'https://cdn.sportnanoapi.com/football/player/';
        this.HttpUrlTeam = 'https://cdn.sportnanoapi.com/football/team/';
    }

    componentDidMount() {
        this.getFootballStat();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onTabClick = (idx) => {
        console.log('_onTabClick', idx);
        this.setState({ selectIdex: idx, data: this._getData(idx, this.state.data) });
    }

    _onPlayerClick = (item) => {
        item = Object.assign(item, { type_id: MatchType.FOOTBALL });
        this.props.history.push({ pathname: '/playerdetail', data: item });
    }

    getFootballStat = async () => {
        let { competition_id } = this.props;
        let result = await Apis.encryptionSeasonStatDetail(MatchType.FOOTBALL, competition_id);
        console.log('getFootballStat', result);
        if (result.code == 200 && result.data) {
            let data = this._getData(100, result.data.players_stats);
            this.setState({ data: data });
        }
    }

    _getData = (idx, data) => {
        if (!data) {
            return data;
        }
        for (let i = 0; i < data.length; i++) {
            if (idx == 0) {
                data[i].value = data[i].assists;
            } else if (idx == 1) {
                data[i].value = data[i].key_passes;
            } else if (idx == 2) {
                data[i].value = data[i].tackles;
            } else if (idx == 3) {
                data[i].value = data[i].saves;
            } else if (idx == 4) {
                data[i].value = data[i].dribble_succ;
            } else if (idx == 100) {
                data[i].value = data[i].goals;
            }
        }

        data = data.sort((a, b) => {
            return b.value - a.value;
        });
        return data;
    }

    _getPlayer = (data, playerId) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id == playerId) {
                return data[i];
            }
        }
        return null;
    }

    _getTeam = (data, team_id) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id == team_id) {
                return data[i];
            }
        }
        return null;
    }

    render() {
        const { classes } = this.props;
        const { data, tabData, selectIdex } = this.state;

        if (!data || data.length == 0) {
            return (
                <Grid container justify='center' alignItems='center' style={{ marginTop: '20vw' }}>
                    <MNoLiving />
                </Grid>
            );
        }

        return (
            <Grid container direction='row' style={{ flex: 1 }} >
                <Grid style={{ width: 80, backgroundColor: '#F2F2F2', height: '90vh' }}>
                    <Table>
                        <TableHead>
                            <TableRow style={{ flex: 1 }} onClick={() => this._onTabClick(100)}>
                                <TableCell align='center' className={selectIdex == 100 ? classes.tabBodyCell1 : classes.tabBodyCell}>射手</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                tabData.map((item, i) => (
                                    <TableRow key={i} onClick={() => this._onTabClick(i)}>
                                        <TableCell align='center' className={selectIdex == i ? classes.tabBodyCell1 : classes.tabBodyCell}>{item}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </Grid>
                <Grid style={{ flex: 1 }}>
                    <Table style={{ flex: 1 }} aria-label="a dense table">
                        <TableHead style={{ backgroundColor: '#EFF5FD', width: '100%' }}>
                            <TableRow style={{ flex: 1 }}>
                                <TableCell align='center' className={classes.conHeadCell} style={{ width: 32 }}>排名</TableCell>
                                <TableCell align='left' className={classes.conHeadCell} style={{ flex: 1 }}>球员</TableCell>
                                <TableCell align='center' className={classes.conHeadCell} style={{ width: 32 }}>球队</TableCell>
                                <TableCell align='center' className={classes.conHeadCell} style={{ width: 32 }}>总数</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data.map((item, i) => (
                                    <TableRow key={i} style={{ flex: 1, }} onClick={() => this._onPlayerClick(item)}>
                                        <TableCell align='center' className={i < 3 ? classes.conBodyCell1 : classes.conBodyCell} style={{ width: 32 }}>{i + 1}</TableCell>
                                        <TableCell align='left' className={classes.conBodyCell} style={{ flex: 1 }}>
                                            <Grid container direction='row'  >
                                                <img src={item.player && (this.HttpUrlPlayer + item.player.logo)} className={classes.icon} alt=''></img>
                                                <Typography style={{ color: '#0d0d0d', fontSize: 10 }}>{item.player && item.player.name_zh}</Typography>
                                            </Grid>
                                        </TableCell>
                                        <TableCell align='center' className={classes.conBodyCell} style={{ width: 32 }}>
                                            <img src={item.team && (this.HttpUrlTeam + item.team.logo)} className={classes.icon} alt=''></img>
                                        </TableCell>
                                        <TableCell align='center' className={classes.conBodyCell} style={{ width: 32 }}>{item.value}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>

        );
    }
}

export default withRouter(withStyles((theme) => ({
    tabBodyCell: {
        fontSize: 10,
        color: '#878787',
        border: 0,
        backgroundColor: 'transparent',
        padding: theme.spacing(1, 0.5, 1, 0.5),
    },
    tabBodyCell1: {
        fontSize: 10,
        color: '#FFF',
        border: 0,
        backgroundColor: '#FC182B',
        padding: theme.spacing(1, 0.5, 1, 0.5),
    },
    conHeadCell: {
        padding: theme.spacing(1, 0.5, 1, 0.5),
        fontSize: 10,
        color: '#0D0D0D'
    },
    conBodyCell1: {
        padding: theme.spacing(1, 0.5, 1, 0.5),
        fontSize: 10,
        color: '#FC182B',
        borderBottom: 'solid 1px #F2F2F2'
    },
    conBodyCell: {
        padding: theme.spacing(1, 0.5, 1, 0.5),
        fontSize: 10,
        color: '#0d0d0d',
        borderBottom: 'solid 1px #F2F2F2'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
        objectFit: 'scale-down'
    }
}))(MatchRankPlayerFootball));